import { AutoComplete, AutoCompleteProps } from 'antd';
import { FC } from 'react';

export const ILSAutoComplete: FC<AutoCompleteProps> = (props) => {
  return <AutoComplete {...props} />;
};
